// This implementation does not allow for type switching - if it goes in a string, it comes out a string:
/*
type operator<T> = (input: T) => T
export default <T>(...fns: operator<T>[]) => (context: T): T => fns.reduce((newContext, fn) => fn(newContext), context)
*/
export default (...fns) => (context) => fns.reduce((newContext, fn) => fn(newContext), context);
//# sourceMappingURL=pipe.js.map